<template>
  <div
    class="activity-photos-field"
  >
    <div
      class="activity-photos-field__label"
    >
      {{ label }}
    </div>

    <div
      class="activity-photos-field__box"
      :class="{ 'activity-photos-field__box--disabled': !photos.length }"
      @click="openDialog"
    >
      <image-field
        class="activity-photos-field__icon"
        src="/img/icons/image-icon.svg"
        contain
        width="20"
        height="20"
      />

      <span
        v-if="photos.length"
        class="activity-photos-field__count"
      >
        {{ photos.length }}
      </span>
    </div>

    <images-preview-dialog
      v-if="showDialog"
      :show-dialog="showDialog"
      :images="photos"
      :dialog-title="label"
      :enable-delete="false"
      @close="showDialog = false"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import ImagesPreviewDialog from '@/global/components/dialogs/ImagesPreviewDialog.vue'
import ImageField from '@/global/components/fields/ImageField.vue'
import { useTranslate } from '@/global/composables/useTranslate'

const props = defineProps({
  // FieldsRenderer passes the field definition through as `config` and the
  // whole row object (here: the activity) as `formData`.
  config: {
    type: Object,
    default: () => ({})
  },
  formData: {
    type: Object,
    default: () => ({})
  }
})

const { translate } = useTranslate()

const showDialog = ref(false)

const label = computed(() => props.config?.label || translate('road-maintenance/temporary_regulation/work_order_details.photo'))

const photos = computed(() => props.formData?.photos || [])

const openDialog = () => {
  if (!photos.value.length) {
    return
  }
  showDialog.value = true
}
</script>

<style scoped>
.activity-photos-field__label {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #111827;
  margin-bottom: 4px;
}

.activity-photos-field__box {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  background-color: #FFFFFF;
  cursor: pointer;
}

.activity-photos-field__box:hover {
  border-color: #65AD45;
}

/* Nothing to preview - keep the field visible (so the row's grid doesn't
   shift) but make it clearly inert. */
.activity-photos-field__box--disabled {
  cursor: default;
  opacity: 0.5;
}

.activity-photos-field__box--disabled:hover {
  border-color: #E5E7EB;
}

/* v-img is a block that grows to fill its flex line - pin it to the icon's
   own size so the count sits right next to it. */
.activity-photos-field__icon {
  flex: 0 0 auto;
}

.activity-photos-field__count {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  color: #111827;
}
</style>
